import axios from 'axios';

export async function getApgJWT() {
  try {
    const cachedToken= localStorage.getItem('apg_jwt');
    const tokenExpiry = localStorage.getItem('apg_jwt_expiry');
    const session_token = localStorage.getItem('session_token')
    console.log('cached token:', cachedToken);
    console.log('TokenExpiry (stored):', tokenExpiry);
    console.log('Current Time (Now):', Date.now());
    if (session_token){
      return session_token
    }
    if (cachedToken && tokenExpiry && Date.now() < parseInt(tokenExpiry)) {
       console.log('Using Cached token (still valid)', cachedToken);
       return cachedToken;
    }
    console.log('Fetching n c apg token');
    const response = await axios.post(process.env.REACT_APP_BASE_URL+'/v1/oauth/jwt', {headers: {
      "Content-Type": "application/json"
  }}, {auth:{
      username: process.env.REACT_APP_OAUTH_USERNAME,
      password: process.env.REACT_APP_OAUTH_PASSWORD
    }
  });

  const newToken = response.data.token;
  console.log("newtoekn", newToken)
  const expiresIn = 500 //900 is 15 mins

  return newToken;
  } catch (err) {
    console.error('Failed to get APG JWT:', err);
    throw err;
  }
}